import { cn } from "~/ui-rtk/utils/tailwind-utils"

type ChartPlaceholderProps = {
  title: string
  icon?: string
  subtitle?: string
  className?: string
  height?: string
}

export default function ChartPlaceholder({
  title,
  icon = "📊",
  subtitle = "Data will appear when available",
  className,
  height = "280px",
}: ChartPlaceholderProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-system-gray-400",
        "bg-system-blue-800/30 rounded-xl border border-dashed border-system-blue-600/50",
        className,
      )}
      style={{ height }}
    >
      <div className="text-4xl mb-3 opacity-50">{icon}</div>
      <div className="text-sm font-medium">{title}</div>
      <div className="text-xs mt-1 opacity-60">{subtitle}</div>
    </div>
  )
}
